{% block uc_icon_picker %}
<div class="uc-icon-picker" :class="{ 'is-disabled': disabled }">

    <label v-if="label" class="uc-icon-picker__label">{{ label }}</label>

    <div v-if="isLoading" class="uc-icon-picker__status">
        {{ $tc('sellops-ultimate-cart.iconPicker.loading') }}
    </div>

    <div v-else-if="loadFailed" class="uc-icon-picker__status uc-icon-picker__status--error">
        {{ $tc('sellops-ultimate-cart.iconPicker.loadError') }}
    </div>

    <div v-else-if="available.length === 0" class="uc-icon-picker__status">
        {{ $tc('sellops-ultimate-cart.iconPicker.emptyLibrary') }}
    </div>

    <template v-else>
        <div class="uc-icon-picker__toolbar">
            <button
                type="button"
                class="uc-icon-picker__toolbar-link"
                :disabled="disabled || allSelected"
                @click="selectAll"
            >
                {{ $tc('sellops-ultimate-cart.iconPicker.selectAll') }}
            </button>
            <span class="uc-icon-picker__toolbar-sep">·</span>
            <button
                type="button"
                class="uc-icon-picker__toolbar-link"
                :disabled="disabled || selected.length === 0"
                @click="selectNone"
            >
                {{ $tc('sellops-ultimate-cart.iconPicker.selectNone') }}
            </button>
        </div>

        <ul class="uc-icon-picker__list">
            <li
                v-for="icon in available"
                :key="icon.file"
                class="uc-icon-picker__item"
                :class="{ 'is-checked': isChecked(icon.file) }"
                @click="toggle(icon.file)"
            >
                <input
                    type="checkbox"
                    class="uc-icon-picker__checkbox"
                    :checked="isChecked(icon.file)"
                    :disabled="disabled"
                    @click.stop="toggle(icon.file)"
                >
                <img :src="icon.url" :alt="icon.label" class="uc-icon-picker__img">
                <span class="uc-icon-picker__file-label">{{ icon.label }}</span>
                <span class="uc-icon-picker__filename">{{ icon.file }}</span>
            </li>
        </ul>
    </template>

    <p v-if="helpText" class="uc-icon-picker__help">{{ helpText }}</p>

</div>
{% endblock %}
